import { render, staticRenderFns } from "./LoanEmiPaymentFormNew.vue?vue&type=template&id=22ee0e20"
import script from "./LoanEmiPaymentFormNew.vue?vue&type=script&lang=js"
export * from "./LoanEmiPaymentFormNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports